(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rgbzone-product-detail-content"] && !Shopify.designMode) return;
  try {
    
  class RGBZoneProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';
      this.tabs = Array.from(this.querySelectorAll('[data-rgbzone-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-rgbzone-panel]'));

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
        tab.addEventListener('keydown', (event) => this.handleKeydown(event, tab));
      });
    }

    activate(activeTab) {
      const activeName = activeTab.dataset.rgbzoneTab;

      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.rgbzonePanel !== activeName;
      });
    }

    handleKeydown(event, currentTab) {
      const currentIndex = this.tabs.indexOf(currentTab);
      let nextIndex = currentIndex;

      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.tabs.length - 1;
      if (nextIndex === currentIndex) return;

      event.preventDefault();
      this.activate(this.tabs[nextIndex]);
      this.tabs[nextIndex].focus();
    }
  }

  if (!customElements.get('rgbzone-product-tabs')) {
    customElements.define('rgbzone-product-tabs', RGBZoneProductTabs);
  }

  } catch(e) { console.error(e); }
})();
})();
